import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import { fetchWishlist, addWishlistItem, deleteWishlistItem } from '~/services/wishlist';
export default {
  fetchWishlistItems(_ref) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      const {
        wishlist
      } = yield fetchWishlist(_this);
      commit(types.SET_WISHLIST_ITEMS, wishlist);
    })();
  },

  addWishlistItem(_ref2, reference) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref2;
      commit(types.ADD_WISHLIST_ITEM, {
        product: {
          reference
        }
      });

      try {
        yield addWishlistItem(_this2, reference);
      } catch (error) {
        console.log(error);
      }
    })();
  },

  deleteWishlistItem(_ref3, reference) {
    let {
      commit
    } = _ref3;
    commit(types.DELETE_WISHLIST_ITEM, reference);

    try {
      deleteWishlistItem(this, reference);
    } catch (error) {
      console.log(error);
    }
  },

  fetchWishlistProducts(_ref4) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref4;
      const {
        wishlist
      } = yield fetchWishlist(_this3, true);
      commit(types.SET_WISHLIST_PRODUCTS, wishlist);
    })();
  }

};